// assets/src/js/initWish.js (경로는 네 구조에 맞게)

const InitWish = () => {
  const body = document.body;

  // frontendAjaxObject 객체가 없으면 중단 (localize_script 로 주입됨)
  if (typeof frontendAjaxObject === 'undefined') return;

  // 비회원 → early return
  // if (!frontendAjaxObject.is_logged_in) return;

  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('.dcraft-wishlist-btn');
    if (!btn) return;

    e.preventDefault();

    if (!frontendAjaxObject.is_logged_in) {
      alert('위시리스트 기능은 회원 전용입니다. 로그인 후 이용해주세요.');
      return;
    }
    const productId = btn.dataset.productId;
    const inWishlist =
      btn.dataset.inWishlist === '1' || btn.dataset.inWishlist === 1;

    const action = inWishlist
      ? 'dcraft_remove_from_wishlist'
      : 'dcraft_add_to_wishlist';

    // AJAX 요청 데이터
    const formData = new FormData();
    formData.append('action', action);
    formData.append('product_id', productId);
    formData.append('nonce', frontendAjaxObject.nonce);

    try {
      const response = await fetch(frontendAjaxObject.ajaxurl, {
        method: 'POST',
        credentials: 'same-origin',
        body: formData,
      });

      const res = await response.json();

      if (!res.success) {
        const msg =
          res.data && res.data.message
            ? res.data.message
            : '통신 중 문제가 발생했습니다.';
        alert(msg);
        return;
      }

      // 상태 토글
      const nowInWishlist = !inWishlist;
      btn.dataset.inWishlist = nowInWishlist ? '1' : '0';

      // UI 변경
      if (nowInWishlist) {
        btn.classList.add('is-in-wishlist');
        btn.textContent = '♥';
      } else {
        btn.classList.remove('is-in-wishlist');
        btn.textContent = '♡';
      }

      // classList에 dcraft-wishlist-btn-refresh 가 있으면 화면 refresh 기능 수행
      if (btn.classList.contains('dcraft-wishlist-btn-refresh')) {
        window.location.reload();
        return;
      }

      // 카운트 업데이트
      // if (res.data && typeof res.data.count !== 'undefined') {
      //   const badge = document.querySelector('.dcraft-wishlist-count');
      //   if (badge) badge.textContent = res.data.count;
      // }
    } catch (err) {
      alert('통신 중 오류가 발생했습니다.');
      console.error(err);
    }
  });
};

export default InitWish;
